export default [
  //  expenses  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "expenses",
      layout: "dashboard",
    },
    path: "/expenses",
    name: "expenses",
    component: () => import("@/layouts/index/ExpenseIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Dépenses de société",
          layout: "dashboard",
        },
        path: "index",
        name: "expenses-index",
        component: () => import("@/views/expenses/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre l'achat",
          layout: "dashboard",
        },
        path: "create",
        name: "expenses-create",
        component: () => import("@/views/expenses/Create.vue"),
      },
    ],
  },
];